import { Nullable } from 'global';
import { TemplatesState } from '../ui/types';
import { VOStageStatus } from '../../types';
import { DepartmentId, Stage, StageId } from '../api';

export function isDepartmentWithWarning(templates: TemplatesState, departmentId: DepartmentId) {
  return !Object.keys(templates[departmentId] ?? {}).length;
}

export function determineStatus(
  stages: Record<StageId, Stage>,
  stage: Stage,
  activeStage: StageId,
  viewedStage: Nullable<StageId>
): VOStageStatus {
  const current = stages[activeStage];

  if (stage.businessProcessFlowStageId === activeStage) {
    return VOStageStatus.Current;
  }

  if (stage.businessProcessFlowStageId === viewedStage) {
    return VOStageStatus.Viewed;
  }

  if (current && current.ordinal < stage.ordinal) {
    return VOStageStatus.Passed;
  }

  return VOStageStatus.Future;
}

export function checkIsStageFieldsExist(stage: Stage) {
  return !!Object.keys(stage?.stageFields ?? {}).length;
}
